"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStakingProvider = exports.StakingProvider = void 0;
var constate_1 = __importDefault(require("constate"));
var react_1 = require("react");
var launchpadConstants_1 = require("../../launchpadConstants");
var hooks_1 = require("../../shared/hooks");
var utils_1 = require("../../shared/utils");
var utils_2 = require("../../staking/utils");
var index_1 = require("./index");
var useDepositAction_1 = require("./useDepositAction");
var useWithdrawAction_1 = require("./useWithdrawAction");
function useStaking(_a) {
    var pool = _a.pool, onTVLChange = _a.onTVLChange;
    var web3 = (0, hooks_1.useWeb3Provider)().web3;
    var _b = (0, hooks_1.useUser)(), account = _b.account, refreshUser = _b.refresh;
    var address = pool.address, pairAddress = pool.pairAddress, decimals = pool.decimals, proxyAddress = pool.proxyAddress;
    var mainToken = (0, utils_2.getStakingTokens)(pool)[0];
    var stakingContract = (0, index_1.useStakingContract)(address);
    var tokenContract = (0, hooks_1.useERC20)(mainToken.address, web3);
    var pairContract = pairAddress
        ? (0, hooks_1.usePairContract)(pairAddress)
        : tokenContract;
    var _c = (0, index_1.useStakingUserStats)({
        stakingContract: stakingContract,
        pairContract: pairContract,
        decimals: decimals,
        rewardDecimals: pool.rewardToken.decimals,
    }), userStats = _c.stats, refreshUserStats = _c.refresh;
    var _d = (0, index_1.useStakingStats)({
        stakingContract: stakingContract,
        pairContract: pairContract,
        isPair: !!pairAddress,
        decimals: decimals,
        pool: pool,
    }), refreshTotalStats = _d.refresh, totalStats = __rest(_d, ["refresh"]);
    var refreshAll = (0, react_1.useCallback)(function () {
        refreshTotalStats();
        refreshUserStats();
        refreshUser();
    }, [refreshTotalStats, refreshUserStats]);
    var withdraw = (0, useWithdrawAction_1.useWithdrawAction)({
        contract: stakingContract,
        decimals: decimals,
        refresh: refreshAll,
    }).withdraw;
    var deposit = (0, useDepositAction_1.useDepositAction)({
        contract: stakingContract,
        decimals: decimals,
        refresh: refreshAll,
    }).deposit;
    var totalValue = totalStats.totalStaked
        .mul((0, utils_1.toWeiBN)(totalStats.stakingTokenPrice))
        .div(launchpadConstants_1.DEC_NORM);
    (0, react_1.useEffect)(function () { return onTVLChange(totalValue); }, [totalValue.toString()]);
    function claim() {
        return stakingContract.methods
            .claim()
            .send({ from: account })
            .then(function () {
            refreshAll();
            return { success: true, msg: 'Successfully claimed' };
        })
            .catch(function (e) {
            return {
                success: false,
                msg: 'Claim failed',
                data: { message: e.message },
            };
        });
    }
    return {
        pool: pool,
        // Stats
        userStats: userStats,
        totalStats: totalStats,
        totalValue: totalValue,
        // Contracts
        stakingContract: stakingContract,
        pairContract: pairContract,
        tokenContract: tokenContract,
        refresh: refreshAll,
        // Methods
        deposit: deposit,
        withdraw: withdraw,
        claim: claim,
    };
}
var _a = (0, constate_1.default)(useStaking), StakingProvider = _a[0], useStakingProvider = _a[1];
exports.StakingProvider = StakingProvider;
exports.useStakingProvider = useStakingProvider;
